module.exports = __webpack_public_path__ + "cdc4f9a415f93cdf778353d501ed65eb.MP3";